import { Tooltip } from "antd-v5";
import React from "react";
import { formatNumber } from "utils/numberUtil";

export function LongOrHybridText({
  value,
}: {
  value: number;
}): React.ReactElement {
  if (!value) return <>{0}</>;
  const hybridText = formatNumber(value);
  const longText = formatNumber(value, "long");
  return hybridText === longText ? (
    <>{hybridText}</>
  ) : (
    <Tooltip title={longText}>{hybridText}</Tooltip>
  );
}
